// extracted by mini-css-extract-plugin
export default {"text":"styles_text__uEMiT","cta":"styles_cta__qSNCk","button":"styles_button__eHE8n"};